document.querySelectorAll(".checkbox-item").forEach(($checkboxItem) => {
  const $input = $checkboxItem.querySelector(".checkbox-input") as HTMLInputElement;

  const update = (checked: boolean) => {
    if (checked) {
      $checkboxItem.classList.add("is-checked");
    } else {
      $checkboxItem.classList.remove("is-checked");
    }
  };

  update($input.checked);

  $input.addEventListener("change", (e: any) => {
    update(e.target.checked);
  });
});
